import { render, staticRenderFns } from "./resumen.vue?vue&type=template&id=0a545904"
import script from "./resumen.vue?vue&type=script&lang=ts"
export * from "./resumen.vue?vue&type=script&lang=ts"
import style0 from "./resumen.vue?vue&type=style&index=0&id=0a545904&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports